module.exports = __webpack_public_path__ + "static/media/flow-1.6866128d.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/flow-1.png
// module id = 198
// module chunks = 0